import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserCollectionDto, UserCollectionDtoInterface} from '../dto/user-collection-dto';
import {UserCollectionsService} from '../user-collections.service';
import {AuthService} from '../../../auth.service';
import {MessageService} from '../../../../messages/message.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '../../../../shared/translate.service';
import {UserQueryDto, UserQueryDtoInterface} from '../../user-queries/dto/user-query-dto';

@Component({
  selector: 'app-user-collection',
  templateUrl: './user-collection.component.html',
  styleUrls: ['./user-collection.component.scss']
})
export class UserCollectionComponent implements OnInit {

  userCollectionDto: UserCollectionDtoInterface;
  private creation: boolean;

  constructor(public activeModal: NgbActiveModal, private translator: TranslateService) { }

  ngOnInit() {
    this.creation = !this.userCollectionDto;
    if (!this.userCollectionDto) {
      this.userCollectionDto = UserCollectionDto.create('');
    } else {
      this.rewriteInstance();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  modalLabel() {
    if (this.creation) {
      return this.translator.translate('UserCollection.creation');
    } else {
      return this.translator.translate('UserCollection.edit.longLabel') + ' ' + this.userCollectionDto.name;
    }
  }

  onSubmit() {
    this.activeModal.close(this.userCollectionDto);
  }

  private rewriteInstance() {
    const emptyCollectionDto = UserCollectionDto.create('');
    emptyCollectionDto.id = this.userCollectionDto.id;
    emptyCollectionDto.itemsCount = this.userCollectionDto.itemsCount;
    emptyCollectionDto.name = this.userCollectionDto.name;
    emptyCollectionDto.description = this.userCollectionDto.description;
    emptyCollectionDto.creationTime = this.userCollectionDto.creationTime;
    this.userCollectionDto = emptyCollectionDto;
  }

}
